import React, { useState } from "react";
import { Tabs, ScrollArea, Box, Group, Title } from "@mantine/core";
import LeaveRequestTable from "../tableLeaveRequest";
import ReviewTable from "../reviewTable/reviewTable";

export default function LeaveTabs() {
  const [title, setTitle] = useState(true);
  return (
    <Tabs defaultValue="pending">
      <Group position="apart" mb="md">
        <Title order={2}>{title ? "Leave Request" : "Reviewed Leave"}</Title>
      </Group>
      <Tabs.List>
        <Tabs.Tab onClick={() => setTitle(true)} value="pending">
          Pending Leave
        </Tabs.Tab>
        <Tabs.Tab onClick={() => setTitle(false)} value="review">
          Reviewed Leave
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="pending">
        {/* <Divider mb="md" /> */}
        <Box>
          <LeaveRequestTable />
        </Box>
      </Tabs.Panel>

      <Tabs.Panel value="review">
        <ReviewTable />
      </Tabs.Panel>
    </Tabs>
  );
}
